import React, { useEffect, useRef, useState } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./MissionBanner.css";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import Heading from "../../../utls/Heading";
import HeadingH1 from "../../../utls/HeadingH1";
const MissonBanner = ({ onLoad }) => {
  const bannerRef = useRef(null); // Reference for the banner
  const [isVisible, setIsVisible] = useState(false); // State to track visibility

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Load content when visible
          }
        });
      },
      { root: null, threshold: 0.1 } // Trigger when 10% of the banner is visible
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      if (bannerRef.current) {
        observer.unobserve(bannerRef.current);
      }
    };
  }, []);

  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div className="">
            <div
              ref={bannerRef}
              className="container-fluid ctm-banner position-relative p-0"
              style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
            >
              {isVisible && (
                <>
                  <img
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/14.%20Case%20studies.webp"
                    alt=""
                    className="w-100"
                    fetchpriority={useHighRes ? "high" : "auto"}
                    loading={useHighRes ? "eager" : "lazy"}
                    onLoad={handleImageLoad}
                  />
                  {imageLoaded ? (
                    <div className="ctm-text position-absolute text-white mt-xxl-5 mt-md-3 mt-3">
                      <p className="fs4 text-uppercase busy grotesk-headings">
                        EMPOWERING
                      </p>
                      <HeadingH1 className="banner-headings w-75">
                        Where Purpose Meets Vision
                      </HeadingH1>
                      <div className="d-flex common-second-content">
                        <div className="ornge-border"></div>
                        <div className="second-content">
                          What drives us to go the extra mile? It’s our
                          commitment to create travel solutions that enhance
                          productivity, comfort, and success for every corporate
                          journey.
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              )}
            </div>
            {imageLoaded ? (
              <div className="container discover-mission">
                <Heading className="customheadings">
                  <span>Discover what drives </span>Blueberry Travel to deliver
                  excellence in corporate travel
                </Heading>
                <p className="mission-first mt-md-4 mt-3">
                  We are strongly committed to delivering secure and exceptional
                  travel experiences to our customers, employees, shareholders,
                  and partners. We acknowledge everyone should enjoy their
                  journey without sacrificing their enjoyment or the security of
                  their route. With a deep understanding of modern business
                  travel complexities, our vast services are planned to make
                  your trip as easy and stress-free as possible.
                </p>
                <p className="mission-second mt-2 mt-md-3">
                  As a result, we look forward to developing a highly active
                  workforce that makes strong decisions for every member of the
                  team for the lasting benefit of our partners and customers.
                </p>
              </div>
            ) : null}
          </div>
        )}
      </BannerWrapper>
      {/* ............................second section after banner.................................. */}
    </>
  );
};

export default MissonBanner;
